import {
  ArrowUpRight,
  Factory,
  Sprout,
  HardHat,
  Truck,
  UtensilsCrossed,
  Hotel,
} from "lucide-react";
import { Reveal } from "../Reveal";

const INDUSTRY_ICONS = [Factory, Sprout, HardHat, Truck, UtensilsCrossed, Hotel];

export const Industries = ({ t }) => (
  <section
    id="cases"
    data-testid="industries-section"
    className="py-24 md:py-36"
    style={{ background: "var(--white)" }}
  >
    <div className="max-w-[1400px] mx-auto px-6 md:px-12">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16 md:mb-20 items-end">
        <div className="md:col-span-8">
          <Reveal>
            <span className="eyebrow mb-8">{t.industries.label}</span>
          </Reveal>
          <Reveal delay={120}>
            <h2 className="display-xl text-[34px] md:text-[48px] lg:text-[56px] mt-6">
              {t.industries.title}
            </h2>
          </Reveal>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {t.industries.items.map((item, i) => {
          const Icon = INDUSTRY_ICONS[i];
          return (
            <Reveal key={item.title} delay={(i % 3) * 120}>
              <article
                data-testid={`industry-card-${i}`}
                className="card-surface h-full flex flex-col p-8 md:p-10"
              >
                <div
                  className="flex items-center justify-center mb-8"
                  style={{
                    width: 64,
                    height: 64,
                    background: "var(--paper)",
                    borderRadius: "var(--radius-md)",
                    color: "var(--gold-500)",
                  }}
                >
                  <Icon size={32} strokeWidth={1.5} />
                </div>
                <div
                  className="eyebrow mb-5"
                  style={{ fontSize: "12px" }}
                >
                  {String(i + 1).padStart(2, "0")} / 06
                </div>
                <h3
                  className="font-serif text-[22px] md:text-[26px] leading-tight mb-4"
                  style={{ color: "var(--heading)" }}
                >
                  {item.title}
                </h3>
                <p
                  className="text-[14px] md:text-[15px] leading-relaxed mb-6 flex-1"
                  style={{ color: "var(--fg-muted)" }}
                >
                  {item.body}
                </p>
                <div
                  className="pt-5 flex items-center justify-end"
                  style={{ borderTop: "1px solid var(--border)" }}
                >
                  <ArrowUpRight
                    size={20}
                    style={{ color: "var(--gold-500)" }}
                  />
                </div>
              </article>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
